// Sticky header — adds .is-scrolled class once user scrolls past 8px,
// hides on scroll down + shows on scroll up after 240px (desktop only).

export function initSiteHeader() {
	const header = document.querySelector('[data-cs-header]');
	if (!header) return;

	let lastY = window.scrollY;
	let ticking = false;

	const update = () => {
		const y = window.scrollY;
		header.classList.toggle('is-scrolled', y > 8);

		if (window.innerWidth >= 1100 && y > 240) {
			if (y > lastY + 6) {
				header.classList.add('is-hidden');
			} else if (y < lastY - 6) {
				header.classList.remove('is-hidden');
			}
		} else {
			header.classList.remove('is-hidden');
		}

		lastY = y;
		ticking = false;
	};

	window.addEventListener('scroll', () => {
		if (!ticking) {
			window.requestAnimationFrame(update);
			ticking = true;
		}
	}, { passive: true });

	update();
}
